<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('evaluationDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>  
        <!-- <h3 class="text-center mb-4">
            <RouterLink :to="'/modeling/' + this.$route.params.id + '/evaluationinfo/' + this.$route.params.evaluationId">
                <button class="btn btn-secondary float-end ">
                    {{ $t('detail') }}
                </button>
            </RouterLink>
            <template v-if="isUserAdmin">
                <button class="btn btn-secondary float-end me-2" @click="showAnalyseEvaluation = true">
                    {{ $t('runSimulation') }}
                </button>
                <button class="btn btn-secondary float-end me-2" @click="showValidateEvaluation = true">
                    {{ $t('validate') }}
                </button>
            </template>
        </h3> -->
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
            <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description" >
            </div>
        </div>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="additionalProportion" required>{{ $t('additionalProportion') }}</label>
                <input v-model="data.additionalProportion" type="number" class="form-control" id="additionalProportion" >
            </div>
            <div class="mb-3 col-md-8">
                <label class="form-label" for="increasingValue" required>{{ $t('increasingValue') }}</label>
                <input v-model="data.increasingValue" type="number" class="form-control" id="increasingValue" >
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-2">
                <input class="form-check-input" v-model="data.recalculateWeight" type="checkbox" id="recalculateWeight">
                <label class="form-check-label ps-2"  for="recalculateWeight">
                    {{ $t('recalculateWeight') }}
                </label>
            </div>
            <div class="col-2">
                <input class="form-check-input" v-model="data.weightAverage" type="checkbox" id="weightAverage">
                <label class="form-check-label ps-2"  for="weightAverage">
                    {{ $t('weightAverage') }}
                </label>
            </div>
            <div class="col-2">
                <input class="form-check-input" v-model="data.multiply" type="checkbox" id="multiply">
                <label class="form-check-label ps-2"  for="multiply">
                    {{ $t('multiply') }}
                </label>
            </div>
        </div>
        <div class="mb-3">
            <h4>{{ $t('evaluationParameters') }}</h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('parameter') }}</th>
                        <th scope="col">{{ $t('weight') }}</th>
                        <th scope="col">{{ $t('useAttribute') }}</th>
                        <th scope="col">{{ $t('weightAttribute') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(evaluationParameter, i) in data.evaluationParameters" class="align-middle"  :key="i">
                        <th scope="row"><i class="fa fa-remove" @click="removeEvaluationParameter(i)"></i></th>
                        <td>
                            <select :id="'parameter_' + i" class="form-select" @change="onSelectChange($event, i)">
                                <option selected disabled>{{ $t('select') }}</option>
                                <template v-if="parameterList.length > 0" >
                                    <option v-for="(parameter, i) in parameterList" :selected="evaluationParameter.parameterId == parameter.id" :key="i" name="parameter" v-bind:value="parameter.id">{{ parameter.name }}</option>
                                </template>
                                <template v-if="kpiList.length > 0" >
                                    <option v-for="(kpi, i) in kpiList" :key="i" :selected="evaluationParameter.kpiId == kpi.id" name="kpi" v-bind:value="kpi.id">{{ kpi.name }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <input v-model="evaluationParameter.weight" type="number" class="form-control" :id="'weight_' + i">
                        </td>
                        <td>
                            <input v-model="evaluationParameter.useAttribute" type="checkbox" class="form-check-input" :id="'useAttribute_' + i">
                        </td>
                        <td>
                            <select :id="'weightAttribute_' + i" class="form-select" v-model="evaluationParameter.weightAttribute" :disabled="!evaluationParameter.useAttribute">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="datasetHeaders.length > 0" >
                                    <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </template>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block" @click="addEvaluationParameter"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="mb-3">
            <h4 class="mb-3">{{ $t('evaluationFilters') }} </h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('sign') }}</th>
                        <th scope="col">{{ $t('number') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(evaluationFilter, i) in data.evaluationFilters" class="align-middle"  :key="i" >
                        <th scope="row"><i class="fa fa-remove" @click="removeEvaluationFilter(i)"></i></th>
                        <td>
                            <select :id="'name_' + i" class="form-select" v-model="evaluationFilter.name">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="datasetHeaders.length > 0" >
                                    <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <select v-model="evaluationFilter.sign" class="form-select"  :id="'sign_' + i"> 
                                <option value="=">=</option>
                                <option value=">">&gt;</option>
                                <option value="<">&lt;</option>
                                <option value=">=">&gt;=</option>
                                <option value="<=">&lt;=</option>
                            </select>
                        </td>
                        <td>
                            <input v-model="evaluationFilter.number" type="number" class="form-control" :id="'number_' + i">
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block"  @click="addEvaluationFilter"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="d-grid gap-2 d-md-flex">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger"  @click="showDeleteEvaluation">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
        <EvaluationDeleteModal v-if="showEvaluationDeleteModal" @reload="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })" @closeDeleteDialog="showEvaluationDeleteModal = false"/>
    </div>
</template>

<script>
import AssetTypeApi from "../../api/server/assetType.js";
import EvaluationApi from "../../api/server/evaluation.js";
import DatasetApi from "../../api/server/dataset.js";
import ModelingApi from "../../api/server/modeling";
import EvaluationDeleteModal from './EvaluationDeleteModal.vue';
import CheckIfUserIsAdmin from '../../authCache';
import kpiApi from "../../api/server/kpi.js";
import parameterApi from "../../api/server/parameter.js";

export default {
    name: "evaluationdetail",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    components: {
        EvaluationDeleteModal
    },
    methods: {
        async onSubmit() {
            if(this.data.name.length > 0) {
                await EvaluationApi.evaluationUpdate(this.$route.params.id, this.data);
                if(!this.checkEvaluationFilters())
                    this.showFiltersWarning();
                else     
                    this.showSuccess();
            } else {
                this.showEmptyNameError();
            }
        },
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsAdmin();

            this.data = await EvaluationApi.evaluationDetail(this.$route.params.id, this.$route.params.evaluationId);

            this.kpi = await kpiApi.kpiDetail(this.$route.params.id, this.data.keyPerformanceIndicatorId);

            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.kpi.assetTypeId);
            this.assetTypeName = assetType.name;

            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);

            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            
            var parameterList = await parameterApi.parameterList(this.$route.params.id);
            this.parameterList = parameterList.filter(a => a.assetTypeId == assetType.id);

            var kpiList = await kpiApi.kpiList(this.$route.params.id);
            this.kpiList = kpiList.filter(a => a.assetTypeId == assetType.id);

            for(var i in this.data.evaluationFilters) {
                var attr = this.data.evaluationFilters[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex(d => d.name == attr.name) < 0) {
                    this.missingDatasetFilterHeaders.push({ name: attr.name, alias: attr.name });
                }
            }

            this.pending = false;
        },
        onSelectChange(event, index) {
            const select = event.target;
            const option = select.options[select.selectedIndex];
            const type = option.getAttribute('name');
            const value = select.value;

            const row = this.data.evaluationParameters[index];
            if (type == "parameter") {
                row.parameterId = Number(value);
                row.kpiId = null;
            } else if (type == "kpi") {
                row.parameterId = null;
                row.kpiId = Number(value);
            }
        },
        removeEvaluationFilter(rowIndex) {
            this.data.evaluationFilters.splice(rowIndex, 1);
        },
        addEvaluationFilter() {
            this.data.evaluationFilters.push({  
                name: "",
                sign: "=",
                number: 0
            })
        },
        removeEvaluationParameter(rowIndex) {
            this.data.evaluationParameters.splice(rowIndex, 1);
        },
        addEvaluationParameter() {
            this.data.evaluationParameters.push({  
                evaluationId: 0,
                parameterId: 0,
                kpiId: 0,
                weight: 0.0,
                useAttribute: false,
                weightAttribute: ""
            })
        },
        showDeleteEvaluation() {
            this.evaluationToDeleteId = this.data.id;
            this.showEvaluationDeleteModal = true;
        },
        checkEvaluationFilters() {
            for(var i in this.data.evaluationFilters) {
                var attr = this.data.evaluationFilters[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 || attr.name == "") 
                    return false;
            }

            return true;
        },
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'evaluationUpdated',
            type: 'success'
        },
        showFiltersWarning: { 
            title: 'warning',
            message: 'evaluationFiltersWarning',
            type: 'warn'
        },
        showError: {
            title: 'error',
            message: 'evaluationErrorUpdate',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            parameter: {},
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                evaluationGroup: [],
                evaluationPackage: [],
                evaluationLimit: []
            },
            showEvaluationDeleteModal: false,
            showAnalyseEvaluation: false,
            showValidateEvaluation: false,
            pending: true,
            modelingName: "",
            parameterList: [],
            kpiList: [],
            evaluationToDeleteId: 0,
            isUserAdmin: false
        }
    }
};
</script>